import { Breadcrumbs, Link, Typography } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import FormContainer from "../../../../../common/components/form_container";
import BottomBar from "../../../../../common/components/bottom_bar";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { TransferList } from "../../../../rh/presentation/pages/TreinamentoFuncionario_cadastro/components/transfer_list";
import { DropDownCentroCusto } from "../../../../../common/components/dropdown_centro_custo";
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";
import { BackButton } from "../../../../../common/components/back_button";
import { DropDown } from "../../../../../common/domain/models/dropdown";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";
import { DefaultAutocomplete } from "../../../../../common/components/default_autocomplete";
import DefaultInput from "../../../../../common/components/default_input";
import { DefaultFormNumericInput } from "../../../../../common/components/default_form_numeric_input";
import { DefaultFormRadioGroupInput } from "../../../../../common/components/default_form_radio_group_input";
import { useMemo } from "react";
import { useImpressaoCadastroSolicitarViewModel } from "../../viewModels/Impressao_cadastrosolicitar_view_model";

export const Impressao_cadastrosolicitar = () => {
  const viewModel = useImpressaoCadastroSolicitarViewModel();

  const corOptions = useMemo(() => {
    return [
      {
        id: 0,
        label: 'Preto e Branco',
        style: {
          backgroundColor: '#d3d3d3',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 1,
        label: 'Colorido',
        style: {
          backgroundColor: '#45b6af',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },

    ];
  }, [
  ]);

  const ddlTipos: DropDown[] = [
    {
      id: 2,
      title: "Todas"
    },
    {
      id: 0,
      title: "Disciplina"
    },
    {
      id: 1,
      title: "Subdisciplina"
    }
  ];

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <BackButton onClick={() => window.history.back()} />
            </div>
          }
        />
      </PageTopBar>

      <form onSubmit={viewModel.handleSubmitProjetoImpressao}>
        <div className=" flex w-full gap-6 flex-col py-10 px-4 mb-16 ">
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit">
              Projetos
            </Link>
            <Typography className="text-primary-green ">Cadastro de Solicitação de Impressão</Typography>
          </Breadcrumbs>

          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium dark:dark:text-zinc-100 ">
              {viewModel.visualizar ? "Visualização" : "Cadastro"} de Solicitação de Impressão
            </h1>
            <RefreshButton onClick={viewModel.handleReloadPage} />
          </div>

          <div className='w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4'>
            <fieldset disabled={viewModel.visualizar}>

              <FormContainer title="Dados da Solicitação" arrangement="fullRow" border>
                <div className="w-full flex flex-col  gap-4">
                  <div className="w-full grid grid-cols-2 gap-4">
                    <DropDownCentroCusto
                      name="idCentroCusto"
                      label="Centro de Custo"
                      required
                      reactHookForm={viewModel.hookForm}
                    />

                    <FormDatePickerInput
                      name="dataSolicitacao"
                      label="Data Solicitação"
                      required
                      reactHookForm={viewModel.hookForm}
                    />

                  </div>

                  <div className="w-full grid grid-cols-2 gap-4">
                    <DefaultFormAutocomplete
                      name='idProjeto'
                      label='Projeto'
                      options={viewModel.ddlProjetos ?? []}
                      required
                      getOptionKey={x => x.id}
                      getOptionLabel={x => x.title}
                      reactHookForm={viewModel.hookForm}

                    />

                    <DropDownFuncionario
                      name="idFuncionarioSolicitante"
                      label="Solicitante"
                      required
                      reactHookForm={viewModel.hookForm}
                    />

                  </div>

                  <div className="w-full grid grid-cols-2 gap-4">
                    <DefaultFormRadioGroupInput
                      name='cor'
                      label='Cor'
                      options={corOptions}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>

                  <div className="w-full grid grid-cols-2 gap-4">
                    <DefaultFormNumericInput
                      name="quantidade"
                      label="Quantidade"
                      required
                      reactHookForm={viewModel.hookForm}

                    />
                    <DefaultFormInput
                      name="tamanho"
                      label="Tamanho"
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>

                  <DefaultFormInput
                    name="observacoesSolicitacao"
                    label="Descrição"
                    multiline
                    rows={3}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>

              </FormContainer>

              {
                !viewModel.visualizar &&
                <FormContainer title="Pesquisar Disciplinas" arrangement="fullRow" border>
                  <div className="w-full flex flex-col gap-6 items-center justify-center">

                    <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
                      <div className="w-full">
                        <DefaultAutocomplete
                          readOnly={false}
                          label='Por'
                          options={ddlTipos}
                          value={ddlTipos.filter(x => viewModel.filters.tipo === x.id)[0] ?? null}
                          getOptionLabel={x => x.title}
                          getOptionKey={x => x.id}
                          onChange={x => viewModel.handleTipoChange(x?.id ?? null)} />

                      </div>

                      <DefaultInput
                        label="Disciplina/ Subdisciplina"
                        name="disciplinaSudisciplina"
                        value={viewModel.filters.descricao ?? ""}
                        onChangeValue={viewModel.handleDescricaoChange}
                      />

                    </div>

                    <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
                      <DefaultInput
                        label="Prancha"
                        name="prancha"
                        value={viewModel.filters.prancha ?? ""}
                        onChangeValue={viewModel.handlePranchaChange}
                      />

                      <DefaultInput
                        label="Revisão"
                        name="revisao"
                        value={viewModel.filters.revisao ?? ""}
                        onChangeValue={viewModel.handleRevisaoChange}
                      />

                    </div>

                    <div className="w-full flex justify-end">
                      <div className="w-[180px]">
                        <PrimaryButton
                          startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                          buttonColor="yellow"
                          onClick={viewModel.handleClearFilters}>
                          Limpar filtros
                        </PrimaryButton>
                      </div>
                    </div>

                  </div>

                </FormContainer>
              }


              <FormContainer title="Disciplinas/Subdisciplinas" arrangement="fullRow" border>

                <TransferList
                  sourceList={viewModel.disciplinasNaoCadastradas}
                  destinationList={viewModel.disciplinasCadastradas}
                  sourceListTitle="Selecione as Disciplinas/Subdisciplinas"
                  destinationListTitle="Disciplinas/Subdisciplinas Selecionados"
                  getItemKey={(x) => x.idDisciplina}
                  getItemLabel={(x) => x.descricao}
                  onSelectionChange={viewModel.handleChangeDisciplinasLista}

                />

              </FormContainer>
            </fieldset>
          </div>
        </div>

        {
          !viewModel.visualizar &&
          <BottomBar>
            <div className="w-full flex justify-end items-center gap-4 p-4">
              <div className="p-2 cursor-pointer font-semibold" onClick={() => window.history.back()}>
                Cancelar
              </div>

              <div className="w-[130px]">
                {viewModel.loading ? (
                  <PrimaryButton>Salvando...</PrimaryButton>
                ) : (
                  <PrimaryButton type="submit" startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </BottomBar>
        }


      </form>

    </>
  );
};
